function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import React, { useReducer } from "react";
import produce from "immer";
import uniq from "lodash/uniq";
import uniqBy from "lodash/uniqBy";
import { groupBy, flatten } from "lodash";
import * as phasesModule from "../../../modules/phases";
var enhanceWithKeys = function(v) {
    var groupByKey = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "id", targetKey = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "key";
    // Group items by their ID and then generate key based on their order within that group
    var grouped = groupBy(v, groupByKey);
    return flatten(Object.values(grouped).map(function(v) {
        return v.map(function(v, i) {
            return _objectSpreadProps(_objectSpread({}, v), _defineProperty({}, targetKey, "".concat(v.id, "-").concat(i)));
        });
    }));
};
var moveItemBetweenGroups = function(dndParams, itemGroups) {
    var dest = dndParams.destination, src = dndParams.source;
    if (!dest) return itemGroups;
    var copyGroup = function(group) {
        return _objectSpreadProps(_objectSpread({}, group), {
            itemRows: group.itemRows.slice()
        });
    };
    var srcGroupIndex = +src.droppableId.split(":")[1];
    var destGroupIndex = +dest.droppableId.split(":")[1];
    var srcGroup = copyGroup(itemGroups[srcGroupIndex]);
    // Make sure to use the same copy when same src and dest
    var destGroup = srcGroupIndex === destGroupIndex ? srcGroup : copyGroup(itemGroups[destGroupIndex]);
    var ref = _slicedToArray(srcGroup.itemRows.splice(src.index, 1), 1), target = ref[0];
    destGroup.itemRows.splice(dest.index, 0, target);
    var result = itemGroups.slice();
    result[srcGroupIndex] = srcGroup;
    result[destGroupIndex] = destGroup;
    return result;
};
/**
 *
 * @param {Array<Object>} cart
 * @returns
 */ var initialState = function(cart) {
    return {
        itemGroups: [
            {
                itemRows: cart.map(function(item) {
                    var itemRow = {
                        item: item,
                        id: item.addonId
                    };
                    if (!item.phase) return itemRow;
                    var phasesBreakdown = item.phasesBreakdown;
                    return _objectSpreadProps(_objectSpread({}, itemRow), {
                        isExpanded: false,
                        allPhases: uniq(phasesBreakdown.phases),
                        allRoles: uniqBy(phasesBreakdown.roles, "label"),
                        phasesBreakdown: phasesBreakdown
                    });
                })
            }, 
        ]
    };
};
export var PhaseAllocationsActionsEnum;
(function(PhaseAllocationsActionsEnum) {
    PhaseAllocationsActionsEnum["ToggleExpanded"] = "toggleExpanded";
    PhaseAllocationsActionsEnum["UpdateData"] = "updateData";
    PhaseAllocationsActionsEnum["UpdatePhase"] = "updatePhase";
    PhaseAllocationsActionsEnum["AddRole"] = "addRole";
    PhaseAllocationsActionsEnum["RemoveRole"] = "removeRole";
    PhaseAllocationsActionsEnum["UpdateRole"] = "updateRole";
    PhaseAllocationsActionsEnum["AddWeek"] = "addWeek";
    PhaseAllocationsActionsEnum["RemoveWeek"] = "removeWeek";
    PhaseAllocationsActionsEnum["MoveWeek"] = "moveWeek";
    PhaseAllocationsActionsEnum["Reset"] = "reset";
    PhaseAllocationsActionsEnum["MoveItem"] = "moveItem";
    PhaseAllocationsActionsEnum["AddGroup"] = "addGroup";
    PhaseAllocationsActionsEnum["RemoveGroup"] = "removeGroup";
    PhaseAllocationsActionsEnum["ThirdPartyReducer"] = "3rdPartyReducer";
    PhaseAllocationsActionsEnum["RemoveItemRow"] = "removeItemRow";
})(PhaseAllocationsActionsEnum || (PhaseAllocationsActionsEnum = {}));
var itemRowReducer = function(draftState, action) {
    switch(action.type){
        case PhaseAllocationsActionsEnum.ToggleExpanded:
            draftState.isExpanded = !draftState.isExpanded;
            return;
        case PhaseAllocationsActionsEnum.UpdateData:
            var ref;
            draftState.phasesBreakdown.data[action === null || action === void 0 ? void 0 : action.y][action === null || action === void 0 ? void 0 : action.x] = ((ref = String(action.hours)) === null || ref === void 0 ? void 0 : ref.endsWith(".")) ? action.hours || 0 : Number(action.hours) || 0;
            return;
        case PhaseAllocationsActionsEnum.UpdatePhase:
            draftState.phasesBreakdown.phases[action === null || action === void 0 ? void 0 : action.phaseIndex] = action.phase;
            return;
        case PhaseAllocationsActionsEnum.AddRole:
            {
                var _phasesBreakdown = draftState.phasesBreakdown, roles = _phasesBreakdown.roles, data = _phasesBreakdown.data, phases = _phasesBreakdown.phases;
                roles.push(roles.slice(-1)[0] || {
                    label: "",
                    rate: {
                        costCents: 0,
                        expenseCents: 0
                    }
                });
                data.push(phases.map(function() {
                    return 0;
                }));
                return;
            }
        case PhaseAllocationsActionsEnum.RemoveRole:
            if ((action === null || action === void 0 ? void 0 : action.roleIndex) !== undefined) {
                draftState.phasesBreakdown.roles.splice(action.roleIndex, 1);
                draftState.phasesBreakdown.data.splice(action.roleIndex, 1);
            } else {
                draftState.phasesBreakdown.roles.pop();
                draftState.phasesBreakdown.data.pop();
            }
            return;
        case PhaseAllocationsActionsEnum.UpdateRole:
            draftState.phasesBreakdown.roles[action === null || action === void 0 ? void 0 : action.roleIndex] = action === null || action === void 0 ? void 0 : action.role;
            return;
        case PhaseAllocationsActionsEnum.AddWeek:
            {
                var _phasesBreakdown1 = draftState.phasesBreakdown, phases1 = _phasesBreakdown1.phases, data1 = _phasesBreakdown1.data;
                phases1.push("");
                data1.forEach(function(dataRow) {
                    return dataRow.push(0);
                });
                return;
            }
        case PhaseAllocationsActionsEnum.RemoveWeek:
            {
                var _phasesBreakdown2 = draftState.phasesBreakdown, phases2 = _phasesBreakdown2.phases, data2 = _phasesBreakdown2.data;
                if (action === null || action === void 0 ? void 0 : action.index) {
                    phases2.splice(action.index, 1);
                    data2.forEach(function(dataRow) {
                        return dataRow.splice(action.index || 0, 1);
                    });
                } else {
                    phases2.pop();
                    data2.forEach(function(dataRow) {
                        return dataRow.pop();
                    });
                }
                return;
            }
        case PhaseAllocationsActionsEnum.MoveWeek:
            {
                var _phasesBreakdown3 = draftState.phasesBreakdown, phases3 = _phasesBreakdown3.phases, data3 = _phasesBreakdown3.data, roles1 = _phasesBreakdown3.roles;
                var droppedColIndex = action.droppedColIndex, draggedColIndex = action.draggedColIndex;
                var tempCols = _toConsumableArray(phases3);
                var tempDataRows = _toConsumableArray(data3);
                tempCols.splice(droppedColIndex || 0, 0, tempCols.splice(draggedColIndex || 0, 1)[0]);
                roles1.forEach(function(role, i) {
                    var reorderedDataRow = _toConsumableArray(data3[i]);
                    reorderedDataRow.splice(droppedColIndex || 0, 0, reorderedDataRow.splice(draggedColIndex || 0, 1)[0]);
                    tempDataRows[i] = reorderedDataRow;
                });
                draftState.phasesBreakdown.phases = tempCols;
                draftState.phasesBreakdown.data = tempDataRows;
                return;
            }
        case PhaseAllocationsActionsEnum.Reset:
            var ref1;
            draftState.phasesBreakdown = phasesModule.utils.flattenPhase((ref1 = draftState.item) === null || ref1 === void 0 ? void 0 : ref1.phase);
            break;
        default:
    }
};
/**
 *
 * @param {ItemGroup} draftState
 * @param {ReducerAction} action
 * @returns
 */ var itemGroupReducer = function(draftState, action) {
    var rowIndex = action.rowIndex;
    switch(action.type){
        case PhaseAllocationsActionsEnum.RemoveItemRow:
            draftState.itemRows.splice(rowIndex, 1);
            return;
        default:
            if (rowIndex !== undefined) {
                itemRowReducer(draftState.itemRows[rowIndex], action);
            }
    }
};
export var phaseAllocationsReducer = function(draftState, action) {
    var groupIndex = action.groupIndex, reducerOverride = action.reducerOverride;
    if (typeof reducerOverride === "function") {
        var shouldSkipDefault = reducerOverride(draftState, action);
        if (shouldSkipDefault) {
            return;
        }
    }
    switch(action.type){
        case PhaseAllocationsActionsEnum.MoveItem:
            draftState.itemGroups = moveItemBetweenGroups(action.dndParams, draftState.itemGroups);
            return;
        case PhaseAllocationsActionsEnum.AddGroup:
            draftState.itemGroups.push({
                itemRows: []
            });
            return;
        case PhaseAllocationsActionsEnum.RemoveGroup:
            {
                var _itemRows;
                var itemGroups = draftState.itemGroups;
                (_itemRows = itemGroups[groupIndex - 1].itemRows).push.apply(_itemRows, _toConsumableArray(itemGroups[groupIndex].itemRows));
                itemGroups.splice(groupIndex, 1);
                return;
            }
        case PhaseAllocationsActionsEnum.ThirdPartyReducer:
            {
                var draftItemGroup = draftState.itemGroups[groupIndex];
                action.handler(draftState, _objectSpreadProps(_objectSpread({}, action), {
                    draftItemGroup: draftItemGroup,
                    draftItemRow: draftItemGroup === null || draftItemGroup === void 0 ? void 0 : draftItemGroup.itemRows[action.rowIndex]
                }));
                return;
            }
        default:
            if (groupIndex !== undefined) {
                itemGroupReducer(draftState.itemGroups[groupIndex], action);
            }
    }
};
// Immer-enhanced reducer
var reducer = produce(phaseAllocationsReducer);
export var usePhasesReducer = function(reducerOverride, phasesConfig, cart) {
    var ref = _slicedToArray(useReducer(reducer, null, function() {
        var baseConfig = phasesConfig || initialState(cart);
        return _objectSpreadProps(_objectSpread({}, baseConfig), {
            itemGroups: baseConfig.itemGroups.map(function(v) {
                return _objectSpreadProps(_objectSpread({}, v), {
                    itemRows: enhanceWithKeys(v.itemRows)
                });
            })
        });
    }), 2), state = ref[0], dispatch = ref[1];
    if (reducerOverride) {
        var _dispatch = dispatch;
        dispatch = function(action) {
            action.reducerOverride = reducerOverride;
            return _dispatch(action);
        };
    }
    var tuple = [
        state,
        dispatch, 
    ];
    return tuple;
};
